import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import drEasyApi from '../Api/Customapi';

export const MAINTENANCE_COMPANIES_QUERY_KEY = ['maintenanceCompanies'];

export const useGetMaintenanceCompanies = () => {
    return useQuery({
        queryKey: MAINTENANCE_COMPANIES_QUERY_KEY,
        queryFn: async () => {
            const res = await drEasyApi.get('/api/Equipments/GetMyMaintenanceCompanies');
            return res.data || [];
        },
        onError: (err) => {
            if (err.response?.status === 403) {
                window.location.href = "/sub";
            } else {
                message.error('Failed to fetch maintenance companies');
            }
        }
    });
};

export const useAddMaintenanceCompany = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (values) => {
            return await drEasyApi.post('/api/Equipments/AddMaintenanceCompany', {
                data: values
            });
        },
        onSuccess: () => {
            queryClient.invalidateQueries(MAINTENANCE_COMPANIES_QUERY_KEY);
            message.success('Maintenance company added successfully');
        },
        onError: (err) => {
            if (err?.response?.status === 400) {
                const errorMessage = err?.response?.data?.message || 'Please check your input and try again';
                message.error(errorMessage);
            } else {
                message.error('Failed to add maintenance company');
            }
        }
    });
};

export const useEditMaintenanceCompany = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ id, values }) => {
            return await drEasyApi.put('/api/Equipments/EditMaintenanceCompany', {
                id: id,
                data: values
            });
        },
        onSuccess: () => {
            queryClient.invalidateQueries(MAINTENANCE_COMPANIES_QUERY_KEY);
            message.success('Maintenance company updated successfully');
        },
        onError: (err) => {
            if (err?.response?.status === 400) {
                const errorMessage = err?.response?.data?.message || 'Please check your input and try again';
                message.error(errorMessage);
            } else {
                message.error('Failed to update maintenance company');
            }
        }
    });
};

export const useDeleteMaintenanceCompany = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (id) => {
            return await drEasyApi.delete('/api/Equipments/DeleteMaintenanceCompany', { 
                params: { Id: id } 
            });
        },
        onSuccess: () => {
            queryClient.invalidateQueries(MAINTENANCE_COMPANIES_QUERY_KEY);
            message.success('Maintenance company deleted successfully');
        },
        onError: () => {
            message.error('Failed to delete maintenance company');
        }
    });
};